<template>
  <div class="cookie-alert">
    <div class="cookie-alert__content">
      <div class="cookie-alert__title">
        Управление cookie-файлами
      </div>
      <span class="text-gray-500">
        Мы используем файлы cookie, чтобы обеспечить наилучшее взаимодействие с сайтом.
      </span>
      <br><br>
      <span class="text-gray-500">
        Оставаясь с нами, вы принимаете
        <router-link :to="{name: 'CookiePolicy'}" target="_blank">
          <span>политику cookie</span>
        </router-link>
      </span>
      <br><br>
      <UiButton
        class="w-100"
        @click="acceptCookie"
      >
        Принять
      </UiButton>
    </div>
  </div>
</template>

<script>
import UiButton from '@/components/ui/UiButton.vue'
export default {
  components: {
    UiButton
  },
  setup(props, { emit }) {
    function acceptCookie () {
      emit('accept-cookie')
    }
    return {
      acceptCookie
    }
  }
}
</script>

<style>
.cookie-alert {
  position: fixed;
  right: 34px;
  bottom: 34px;
  z-index: 1001;
  box-sizing: border-box;
  max-height: calc(100vh - 2 * 34px);
  max-width: 358px;
  padding: 17px 24px 20px 19px;
  background-color: rgb(255, 255, 255);
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  border-radius: 20px;
  overflow: hidden;
}
.cookie-alert__title {
  font-weight: 700;
  padding: 0;
  margin: 0;
  margin-bottom: 5px;
}
.text-gray-500 {
  opacity: 0.6;
}
@media screen and (max-width: 475px) {
  .cookie-alert {
    right: 50%;
    transform: translate(50%, 0);
    width: calc(100% - 30px);
  }
}
</style>